var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerIcon1Mob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7389 13.547L29.583 13.7266C29.388 13.9452 29.1125 14.0817 28.8149 14.107C28.5174 14.1323 28.2214 14.0443 27.99 13.8619L15.6817 3.88009C15.4909 3.72488 15.2495 3.63977 15 3.63977C14.7506 3.63977 14.5092 3.72488 14.3184 3.88009L2.00992 13.8619C1.77847 14.0444 1.48248 14.1323 1.18495 14.1071C0.887412 14.0818 0.61182 13.9453 0.416819 13.7266L0.26096 13.5471C0.0704094 13.3241 -0.0217634 13.0376 0.0043512 12.7495C0.0304658 12.4614 0.172772 12.1948 0.40053 12.0073L14.8367 0.300682C14.8822 0.262939 14.9401 0.242188 15.0001 0.242188C15.06 0.242188 15.118 0.262939 15.1635 0.300682L29.5996 12.0073C29.8271 12.195 29.9691 12.4616 29.9952 12.7496C30.0212 13.0376 29.9292 13.324 29.7389 13.547ZM25.1797 25.9641V13.5403L14.9997 5.2854L5.34537 13.1146V25.9641C5.34551 26.046 5.37926 26.1246 5.43921 26.1825C5.49916 26.2404 5.58043 26.2729 5.66518 26.273H10.5263V18.4205C10.5266 18.1177 10.6512 17.8273 10.8728 17.6131C11.0943 17.3989 11.3947 17.2785 11.708 17.2782H18.817C19.1303 17.2786 19.4307 17.3991 19.6523 17.6132C19.8739 17.8273 19.9986 18.1177 19.9991 18.4205V26.273H24.8598C24.9446 26.2729 25.0259 26.2404 25.0858 26.1825C25.1458 26.1246 25.1796 26.046 25.1797 25.9641ZM18.4473 26.273H12.0781V18.7783H18.4473V26.273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon1Mob);
export default __webpack_public_path__ + "static/media/banner_icon1mob.0c1c5bcb234ce3adb0fd28e2899e0c32.svg";
export { ForwardRef as ReactComponent };